export const iconsMap: { [key: string]: string } = {
  error: 'error',
  info: 'info',
  warning: 'warning',
  success: 'check'
};
